<template>
  <div>
    <device-list deviceType="CFFX"></device-list>
  </div>
</template>

<script>
import DeviceList from "./DeviceList.vue";
export default {
  components: {
    DeviceList,
  },
};
</script>

<style lang="scss" scoped></style>
